import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ClockIcon } from 'lucide-react';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState(10800);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section id="pricing" className="py-10 md:py-14 px-4 bg-[#F5F0FF]" data-id="element-82">
      <div className="max-w-7xl mx-auto" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-10" data-id="element-84">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D3F]" data-id="element-85">
            Elegí el pack que mejor se adapte a vos
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-stretch justify-center max-w-6xl mx-auto" data-id="element-86">
          {/* Mega Pack (Mobile: Order 1, Desktop: Order 3) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="order-1 md:order-3 w-full md:w-1/3 bg-white rounded-3xl p-6 sm:p-8 shadow-xl border-4 border-[#FF6B8A] relative flex flex-col z-10 md:scale-105" data-id="element-87">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#FFD166] text-[#2D2D3F] font-black px-4 py-1.5 rounded-full shadow-md text-sm sm:text-base whitespace-nowrap" data-id="element-88">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="mb-4 flex justify-center" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/ovxazyqe6TbNyon72GLS97/MEGA_PACK.png" alt="Mega Pack Disney" className="w-full max-w-[200px] object-contain drop-shadow-md" data-id="element-90" />
            </div>
            <div className="mb-5 text-center md:text-left" data-id="element-91">
              <h3 className="text-2xl sm:text-3xl font-extrabold text-[#2D2D3F] mb-1" data-id="element-92">
                Mega Pack Disney
              </h3>
              <p className="text-[#6B7280] font-medium text-sm sm:text-base" data-id="element-93">
                10 libros coloreables Disney + 3 bonus extra
              </p>
            </div>
            <div className="mb-6 flex-grow" data-id="element-94">
              <ul className="space-y-3" data-id="element-95">
                {['La mejor relación cantidad/precio', 'Descarga inmediata', 'Imprimí sin límites'].map((feature, idx) => <li key={idx} className="flex items-start text-[#2D2D3F] font-medium text-sm sm:text-base" data-id="element-96">
                    <CheckIcon className="w-5 h-5 text-[#FF6B8A] mr-2 shrink-0 mt-0.5" data-id="element-97" />
                    <span data-id="element-98">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-auto text-center md:text-left" data-id="element-99">
              <div className="mb-4" data-id="element-100">
                <span className="text-gray-400 line-through text-sm sm:text-base block" data-id="element-101">
                  $59.990
                </span>
                <span className="text-3xl sm:text-4xl font-extrabold text-[#FF6B8A]" data-id="element-102">
                  🔥 $29.990 ARS
                </span>
              </div>

              <div className="mb-4 bg-[#FFF5F7] border border-[#FFD1D9] rounded-xl p-3 flex flex-col items-center justify-center shadow-sm" data-id="element-103">
                <span className="text-xs font-bold text-[#FF6B8A] uppercase tracking-wide mb-1" data-id="element-104">
                  Esta oferta termina en:
                </span>
                <div className="flex items-center gap-1.5 font-mono font-bold text-xl text-[#2D2D3F]" data-id="element-105">
                  <ClockIcon className="w-5 h-5 text-[#FF6B8A]" data-id="element-106" />
                  {formatTime(hours)}:{formatTime(minutes)}:
                  {formatTime(seconds)}
                </div>
              </div>

              <a href="https://pago.atlasdigitalhub.com/cart/42615279681634:1" className="block w-full py-3 sm:py-4 px-4 rounded-full font-bold bg-[#FF6B8A] text-white hover:bg-[#ff5275] shadow-lg transition-all text-base sm:text-lg text-center" data-id="element-107">
                QUIERO EL MEGA PACK
              </a>
              <p className="text-xs sm:text-sm text-[#6B7280] mt-4 text-center" data-id="element-108">
                El más elegido porque incluye toda la colección con el mejor
                valor.
              </p>
            </div>
          </motion.div>

          {/* Pack Básico (Mobile: Order 2, Desktop: Order 1) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="order-2 md:order-1 w-full md:w-1/3 bg-white rounded-3xl p-6 sm:p-8 shadow-md border border-gray-100 flex flex-col" data-id="element-109">
            <div className="mb-4 flex justify-center" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/8Nencbag8hzm7BBFiApiwb/PACK_BASE.png" alt="Pack Básico" className="w-full max-w-[160px] object-contain drop-shadow-md" data-id="element-111" />
            </div>
            <div className="mb-5 text-center md:text-left" data-id="element-112">
              <h3 className="text-xl sm:text-2xl font-bold text-[#2D2D3F] mb-1" data-id="element-113">
                Pack Básico
              </h3>
              <p className="text-[#6B7280] text-sm sm:text-base" data-id="element-114">
                4 colecciones de coloreables Disney
              </p>
            </div>
            <div className="mb-6 flex-grow" data-id="element-115">
              <ul className="space-y-3" data-id="element-116">
                {['4 colecciones', 'Descarga inmediata', 'Imprimí sin límites'].map((feature, idx) => <li key={idx} className="flex items-start text-[#2D2D3F] text-sm sm:text-base" data-id="element-117">
                    <CheckIcon className="w-5 h-5 text-[#9B8FE8] mr-2 shrink-0 mt-0.5" data-id="element-118" />
                    <span data-id="element-119">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-auto text-center md:text-left" data-id="element-120">
              <div className="text-2xl sm:text-3xl font-bold text-[#2D2D3F] mb-4" data-id="element-121">
                $14.990 ARS
              </div>
              <a href="https://pago.atlasdigitalhub.com/cart/42615279747170:1" className="block w-full py-3 px-4 rounded-full font-bold border-2 border-[#9B8FE8] text-[#9B8FE8] hover:bg-[#9B8FE8] hover:text-white transition-colors text-sm sm:text-base text-center" data-id="element-122">
                QUIERO EL PACK BÁSICO
              </a>
            </div>
          </motion.div>

          {/* Pack Familiar (Mobile: Order 3, Desktop: Order 2) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} className="order-3 md:order-2 w-full md:w-1/3 bg-white rounded-3xl p-6 sm:p-8 shadow-md border border-gray-100 flex flex-col" data-id="element-123">
            <div className="mb-4 flex justify-center" data-id="element-124">
              <img src="https://cdn.magicpatterns.com/uploads/7QAMdcjDiVzPaBotXieEb9/PACK_FAMILIAR.png" alt="Pack Familiar" className="w-full max-w-[180px] object-contain drop-shadow-md" data-id="element-125" />
            </div>
            <div className="mb-5 text-center md:text-left" data-id="element-126">
              <h3 className="text-xl sm:text-2xl font-bold text-[#2D2D3F] mb-1" data-id="element-127">
                Pack Familiar
              </h3>
              <p className="text-[#6B7280] text-sm sm:text-base" data-id="element-128">
                7 colecciones completas
              </p>
            </div>
            <div className="mb-6 flex-grow" data-id="element-129">
              <ul className="space-y-3" data-id="element-130">
                {['7 colecciones', 'Más variedad para elegir', 'Descarga inmediata', 'Imprimí sin límites'].map((feature, idx) => <li key={idx} className="flex items-start text-[#2D2D3F] text-sm sm:text-base" data-id="element-131">
                    <CheckIcon className="w-5 h-5 text-[#9B8FE8] mr-2 shrink-0 mt-0.5" data-id="element-132" />
                    <span data-id="element-133">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-auto text-center md:text-left" data-id="element-134">
              <div className="text-2xl sm:text-3xl font-bold text-[#2D2D3F] mb-4" data-id="element-135">
                $19.990 ARS
              </div>
              <a href="https://pago.atlasdigitalhub.com/cart/42615279714402:1" className="block w-full py-3 px-4 rounded-full font-bold border-2 border-[#9B8FE8] text-[#9B8FE8] hover:bg-[#9B8FE8] hover:text-white transition-colors text-sm sm:text-base text-center" data-id="element-136">
                QUIERO EL PACK FAMILIAR
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}